import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private readonly tokenKey = 'token';
  private isBrowser: boolean;

  private tokenSubject = new BehaviorSubject<string | null>(null);
  token$ = this.tokenSubject.asObservable();

  constructor(
    private _HttpClient: HttpClient,
    private _Route: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);

    if (this.isBrowser) {
      this.tokenSubject.next(window.localStorage.getItem(this.tokenKey));
    }
  }

  user_login(person: any): Observable<any> {
    return this._HttpClient.post(`${environment.Server_URL}/login`, person);
  }

  setToken(token: string): void {
    if (!this.isBrowser) {
      return;
    }

    window.localStorage.setItem(this.tokenKey, token);
    this.tokenSubject.next(token);
  }

  getToken(): string | null {
    if (!this.isBrowser) {
      return null;
    }

    return window.localStorage.getItem(this.tokenKey);
  }

  removeToken(): void {
    if (!this.isBrowser) {
      return;
    }

    window.localStorage.removeItem(this.tokenKey);
    this.tokenSubject.next(null);
  }

  logout(): void {
    if (this.isBrowser) {
      window.localStorage.removeItem(this.tokenKey);
      window.localStorage.removeItem('username');
      window.localStorage.removeItem('user');
      window.localStorage.removeItem('user_cv');
      window.localStorage.removeItem('user_cv_url');
      window.localStorage.removeItem('user_id');
    }

    this.tokenSubject.next(null);
    this._Route.navigate(['/Home']);
  }

  isLoggedIn(): boolean {
    return !!this.getToken();
  }
}
